import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    ApiHandler,
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    getActiveReleaseNumber,
    ReleaseNumberList,
    testParameter,
} from "@tSchaedlerYesco/Services/ReleaseOrderService";
import { CustomApiHandler } from "@tSchaedlerYesco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<ReleaseNumberList, testParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        // Make API call using populated `apiParameter`
        props.apiResult = await getActiveReleaseNumber(props.apiParameter);
    } catch (error) {
        console.error("Error while fetching release numbers:", error);
    }
};

// Combine the handlers into a chain
export const chain = [PopulateApiParameter, RequestDataFromApi];

// Create a handler chain runner
const getReleaseNumberData = createHandlerChainRunner(chain, "getSubscribedProduct");

export default getReleaseNumberData;
